import React from "react";
import { statusLabel, statusColors } from "@/lib/format";

export const StatusBadge = ({ status }) => {
    const c = statusColors[status] || statusColors.draft;
    return (
        <span
            data-testid={`status-badge-${status}`}
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-[11px] font-bold uppercase tracking-wider ${c.bg} ${c.text} ${c.border}`}
        >
            <span
                className={`w-1.5 h-1.5 rounded-full ${c.dot} ${
                    status === "analyzing" ? "pulse-dot" : ""
                }`}
            />
            {statusLabel[status] || status}
        </span>
    );
};

export default StatusBadge;
